// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2V7ay","sendOtp":"AuthorizeToLogin_sendOtp__1ZKbE"};